<i18n>
{
  "de": {
    "subscriptions": "Abos",
    "shop": "Shop"
  },
  "en": {
    "subscriptions": "Subscriptions",
    "shop": "Shop"
  }
}
</i18n>

<template>
  <div>
    <div
      v-if="sortedRewards.length || sortedProducts.length"
      class="purchasables-controls"
    >
      <button
        v-show="sortedRewards.length"
        :class="{
          'is-primary': showRewards,
          'is-one-column is-fullwidth is-small': $mq === 'sm',
          'is-one-column is-fullwidth is-medium': $mq === 'md',
          'is-three-colum-widest is-small': $mq === 'xxl',
          'is-three-colum-wide is-small': $mq === 'xl',
          'is-three-colum-medium is-small': $mq === 'lgr',
          'is-three-colum-narrow is-small': $mq === 'lg',
          'no-margin': !sortedProducts.length
        }"
        class="button"
        @click="toggleRewards"
      >
        {{ $t('subscriptions') }}
      </button>

      <button
        v-show="sortedProducts.length"
        :class="{
          'is-primary': showProducts,
          'is-one-column is-fullwidth is-small': $mq === 'sm',
          'is-one-column is-fullwidth is-medium': $mq === 'md',
          'is-three-colum-widest is-small': $mq === 'xxl',
          'is-three-colum-wide is-small': $mq === 'xl',
          'is-three-colum-medium is-small': $mq === 'lgr',
          'is-three-colum-narrow is-small': $mq === 'lg',
          'no-margin': !sortedRewards.length
        }"
        class="button is-small"
        @click="toggleProducts"
      >
        {{ $t('shop') }}
      </button>
    </div>
    <div v-show="showRewards && sortedRewards.length">
      <div
        v-show="isMobileView && artist.rewards.length > 0"
        class="container has-text-centered mobile-purchasable-title"
      >
        <h3 class="title is-3 has-text-weight-semibold pb-5">
          {{ $t('subscriptions') }}
        </h3>
      </div>
      <profile-reward
        v-for="(reward, index) in sortedRewards"
        :key="reward._id"
        :reward="reward"
        :sideview="sideview"
        :index="index"
      />
    </div>
    <div v-show="showProducts && sortedProducts.length">
      <div
        v-show="isMobileView && artist.products.length > 0"
        class="container has-text-centered mobile-purchasable-title"
      >
        <h3 class="title is-3 has-text-weight-semibold pb-5">
          {{ $t('shop') }}
        </h3>
      </div>
      <profile-product
        v-for="(product, index) in sortedProducts"
        :key="product._id"
        :product="product"
        :sideview="sideview"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import profileReward from '~/components/profile-reward'
import profileProduct from '~/components/profile-product'
export default {
  props: ['sideview'],
  components: {
    profileReward,
    profileProduct
  },

  data() {
    return {
      showProducts: false,
      showRewards: true
    }
  },

  computed: {
    ...mapState(['artist', 'selectedPurchasables']),
    sortedRewards() {
      if (this.artist && this.artist.rewards) {
        return this.artist.rewards.slice().sort((a, b) => {
          if (a.amount > b.amount) {
            return 1
          }
          if (a.amount < b.amount) {
            return -1
          }
          return 0
        })
      }
      return []
    },
    sortedProducts() {
      if (this.artist && this.artist.products) {
        return this.artist.products.slice().sort((a, b) => {
          const amountA = a.minAmount > 0 ? a.minAmount : a.amount
          const amountB = b.minAmount > 0 ? b.minAmount : b.amount
          if (amountA > amountB) {
            return 1
          }
          if (amountA < amountB) {
            return -1
          }
          return 0
        })
      }
      return []
    }
  },

  methods: {
    toggleRewards() {
      this.showRewards = true
      this.showProducts = false
      this.$store.commit('toggleSelectedPurchasables', 'rewards')
    },
    toggleProducts() {
      this.showRewards = false
      this.showProducts = true
      this.$store.commit('toggleSelectedPurchasables', 'products')
    }
  },
  mounted() {
    if (
      this.selectedPurchasables === 'products' ||
      (!this.sortedRewards.length && this.sortedProducts.length)
    ) {
      this.toggleProducts()
    }
  }
}
</script>

<style lang="scss">
.mobile-purchasable-title {
  background-color: black;

  h3 {
    color: white;
    padding-top: 5px;
    line-height: 1em;
  }
}
</style>
<style lang="scss">
.purchasables-controls {
  padding: 0;
  margin: 0 0 15px 0;
  display: flex;
  justify-content: space-between;

  button {
    margin: 0px;
    flex-grow: 1;
    cursor: pointer;

    &.no-margin {
      margin-left: 0px !important;
      width: 100%;
    }

    &.is-one-colum {
      padding-left: 60px;
      padding-right: 60px;
    }

    &.is-three-colum-narrow {
      padding-left: 10px;
      padding-right: 10px;
    }

    &.is-three-colum-medium {
      padding-left: 20px;
      padding-right: 20px;
    }

    &.is-three-colum-wide {
      padding-left: 30px;
      padding-right: 30px;
    }
  }
}
</style>
